import api from "../api";

export const useVerifyUserKyc = (data) =>
  api.put(`/user/${data.email}/verify-kyc`,{id:data.id,remark:" "}).then((res) => res.data);


  export const useDeclineUserKyc = (data) => {
    const data2={"remark":data.remark}
     return api.put(`/user/${data?.email}/decline-kyc`, data2).then((res) => res.data);
};